export default __webpack_public_path__ + "static/media/mechanika.0f857cd9.pdf";